<template>
  <div class="video-detail-page">
    <!-- 头部导航 -->
    <!-- <header class="header">
      <div class="header-container">
        <div class="header-left">
          <div class="logo">
            <span class="material-symbols-outlined logo-icon">school</span>
            <h2 class="brand-name">智慧学习平台</h2>
          </div>
          <div class="search-box">
            <span class="material-symbols-outlined search-icon">search</span>
            <input
              type="text"
              placeholder="搜索课程..."
            />
          </div>
        </div>
        <div class="header-right">
          <nav class="nav-menu">
            <a href="javascript:;" class="nav-link">我的培训</a>
            <a href="javascript:;" class="nav-link active">打卡</a>
            <a href="javascript:;" class="nav-link">资料库</a>
          </nav>
          <div class="divider"></div>
          <div class="user-info">
            <div class="user-text">
              <span class="user-name">{{ userInfo.userName || '未登录' }}</span>
              <span class="user-status">
                <span class="status-dot"></span>
                闲置在线
              </span>
            </div>
            <div class="user-avatar">
              <img :src="getUserAvatar" alt="用户头像" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;" />
            </div>
          </div>
        </div>
      </div>
    </header> -->

    <!-- 主体内容 -->
    <main class="main-content">
      <div class="content-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <router-link to="/activityVideo" class="breadcrumb-link">集中活动</router-link>
          <i class="el-icon-arrow-right breadcrumb-separator"></i>
          <span class="breadcrumb-current">集中学习打卡</span>
        </div>

        <!-- 页面标题 -->
        <div class="page-header">
          <h1 class="page-title">📚 集中学习活动</h1>
          <p class="page-subtitle">请核对活动信息并完成拍照打卡。</p>
        </div>

        <!-- 活动信息卡片 -->
        <div class="activity-card">
          <div class="activity-thumbnail" @click="playVideo" style="cursor: pointer;">
            <div class="thumbnail-bg" :style="{ backgroundImage: 'url(' + activityInfo.videoCover + ')' }"></div>
            <div class="thumbnail-overlay">
              <div class="play-btn">
                <i class="el-icon-video-play"></i>
              </div>
            </div>
          </div>
          <div class="activity-info">
            <div class="activity-content">
              <div class="activity-name-section">
                <span class="activity-label">视频标题</span>
                <h3 class="activity-name">{{ activityInfo.name }}</h3>
              </div>
              <div class="activity-details">
                <div class="detail-item">
                  <span class="detail-label">作者：</span>
                  <span class="detail-value">{{ activityInfo.author }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">发布时间：</span>
                  <span class="detail-value">{{ activityInfo.time }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">分类：</span>
                  <span class="detail-value">{{ activityInfo.category }}</span>
                </div>
                <div class="detail-item" v-if="activityInfo.tags">
                  <span class="detail-label">标签：</span>
                  <span class="detail-value">{{ activityInfo.tags }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">观看次数：</span>
                  <span class="detail-value">{{ activityInfo.viewCount }} 次</span>
                </div>
              </div>
              <div class="video-description" v-if="activityInfo.videoDesc">
                <div class="detail-label">视频描述：</div>
                <div class="detail-value" v-html="activityInfo.videoDesc"></div>
              </div>
            </div>
            <div class="activity-requirement">
              <i class="el-icon-info"></i>
              打卡要求：{{ requireCheckIn === 1 ? '要求拍照打卡' : '可选拍照打卡' }}
            </div>
          </div>
        </div>

        <!-- 打卡表单 -->
        <form @submit.prevent="handleSubmit" class="checkin-form">
          <!-- 拍照区域 -->
          <div class="form-section">
            <label class="form-label">📷 拍照区域 <span v-if="requireCheckIn === 0" class="optional-tag">（可选）</span></label>
            <div class="upload-area" @click="uploadedImagePath ? null : handleUploadClick" :class="{ 'has-photo': uploadedImagePath }">
              <div class="viewfinder-corner corner-tl"></div>
              <div class="viewfinder-corner corner-tr"></div>
              <div class="viewfinder-corner corner-bl"></div>
              <div class="viewfinder-corner corner-br"></div>

              <!-- 未拍照时显示 -->
              <div class="upload-content" v-if="!uploadedImagePath">
                <div class="upload-icon">
                  <i class="el-icon-picture"></i>
                </div>
                <div class="upload-text">
                  <h4>上传照片</h4>
                  <p>请拍摄学习现场照片作为凭证</p>
                </div>
                <button type="button" class="camera-btn" @click.stop.prevent="handleUploadClick">
                  📷 调用摄像头
                </button>
              </div>

              <!-- 已拍照时显示预览 -->
              <div class="photo-preview" v-else>
                <img :src="buildMediaUrl(uploadedImagePath)" alt="打卡照片" />
                <div class="photo-overlay">
                  <button type="button" class="retake-btn" @click.stop="retakePhoto">
                    <i class="el-icon-refresh"></i>
                    重新拍照
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 打卡说明 -->
          <div class="form-section">
            <label for="note" class="form-label">📝 打卡说明：<span class="required-tag">*</span></label>
            <div class="textarea-wrapper">
              <textarea
                id="note"
                v-model="note"
                placeholder="请输入学习心得或备注信息..."
                rows="4"
                maxlength="500"
                class="form-textarea"
              ></textarea>
              <div class="char-count">{{ note.length }}/500</div>
            </div>
          </div>

          <!-- 提交按钮 -->
          <div class="form-actions">
            <button type="submit" class="submit-btn">
              <i class="el-icon-success"></i>
              提交打卡
            </button>
            <button type="button" class="history-btn" @click="viewHistory">
              <i class="el-icon-time"></i>
              查看我的打卡
            </button>
          </div>
        </form>
      </div>
    </main>

    <!-- 手机拍照兜底：不改变页面布局，仅用于调用系统相机/相册 -->
    <input
      ref="cameraFallbackInput"
      type="file"
      accept="image/*"
      capture="environment"
      class="camera-fallback-input"
      @change="handleFallbackFileChange"
    />

    <!-- 摄像头弹窗 -->
    <div class="camera-modal" v-if="showCameraModal" @click.self="closeCamera">
      <div class="camera-container">
        <div class="camera-header">
          <h3>📷 拍照打卡</h3>
          <button class="close-btn" @click="closeCamera">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="camera-body">
          <video ref="cameraVideo" autoplay playsinline muted class="camera-video"></video>
          <canvas ref="photoCanvas" style="display: none;"></canvas>
        </div>
        <div class="camera-footer">
          <button class="capture-btn" @click="takePhoto">
            <i class="el-icon-picture"></i>
            拍照
          </button>
        </div>
      </div>
    </div>

    <!-- 视频播放器弹窗 -->
    <div class="video-player-modal" v-if="showVideoModal" @click.self="closeVideoPlayer">
      <div class="video-player-container">
        <div class="video-player-header">
          <h3>{{ activityInfo.name }}</h3>
          <button class="close-btn" @click="closeVideoPlayer">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="video-player-body">
          <video
            ref="videoPlayer"
            :src="activityInfo.videoUrl"
            controls
            controlsList="nodownload"
            class="video-player"
            @loadedmetadata="onVideoLoaded"
            @loadstart="handlePlayerLoadStart"
            @loadeddata="handlePlayerLoadedData"
            @canplay="handlePlayerCanPlay"
            @playing="handlePlayerPlaying"
            @waiting="handlePlayerWaiting"
            @stalled="handlePlayerStalled"
            @timeupdate="handlePlayerTimeUpdate"
            @progress="handlePlayerProgress"
            @pause="handlePlayerPause"
            @ended="handlePlayerEnded"
            @error="handlePlayerError"
          >
            您的浏览器不支持视频播放
          </video>
          <div v-if="isVideoLoading && !videoLoadError" class="player-loading-overlay">
            <div class="player-loading-content">
              <i class="el-icon-loading"></i>
              <span>{{ videoLoadingText }}</span>
            </div>
          </div>
          <div v-else-if="videoLoadError" class="player-loading-overlay is-error">
            <p class="player-loading-text">{{ videoLoadError }}</p>
          </div>
          <div v-if="videoDuration > 0" class="player-progress-wrap">
            <div class="player-progress-track">
              <div class="player-progress-buffered" :style="{ width: bufferedPercent + '%' }"></div>
              <div class="player-progress-played" :style="{ width: progressPercent + '%' }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVideoActivityById, getVideoById, saveApeArticle, uploadFile } from '@/api/api'
import { mapGetters } from 'vuex'
import videoProgressMixin from '@/mixins/videoProgressMixin'
import { DEFAULT_AVATAR_PLACEHOLDER, DEFAULT_VIDEO_PLACEHOLDER } from '@/utils/placeholders'

export default {
  name: 'PublicVideoDetail',
  mixins: [videoProgressMixin],
  data() {
    return {
      videoId: '',
      note: '',
      videoDetail: {},
      requireCheckIn: 0,
      activityInfo: {
        name: '',
        videoName: '',
        time: '',
        author: '',
        category: '',
        tags: '',
        viewCount: 0
      },
      // 摄像头和拍照相关
      showCameraModal: false,
      cameraStream: null,
      capturedImage: null,
      uploadedImagePath: null,
      isSubmitting: false,
      isOpeningCamera: false,
      // 视频播放器相关
      showVideoModal: false,
      isVideoLoading: false,
      videoLoadingText: '视频加载中...',
      videoLoadError: '',
      progressPercent: 0,
      bufferedPercent: 0,
      videoDuration: 0
    }
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    userInfo() {
      // 优先从 Vuex 获取，如果没有则从 localStorage 获取（向后兼容）
      return this.getUserInfo || JSON.parse(localStorage.getItem('user_info') || '{}')
    },
    getUserAvatar() {
      if (this.userInfo && this.userInfo.avatar) {
        return this.buildMediaUrl(this.userInfo.avatar)
      }
      return DEFAULT_AVATAR_PLACEHOLDER
    }
  },
  created() {
    this.videoId = this.$route.params.id
    if (!this.videoId) {
      this.$message.error('视频ID不存在')
      this.$router.push('/activityVideo')
      return
    }
    this.loadUserInfo()
    this.loadVideoDetail()
    this.loadVideoManage()

    // 页面隐藏/离开时，确保关闭摄像头流
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    window.addEventListener('pagehide', this.handlePageHide)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('pagehide', this.handlePageHide)
    this.closeCamera()
  },
  beforeRouteLeave(to, from, next) {
    this.closeCamera()
    next()
  },
  methods: {
    getBackendHost() {
      const configuredHost = (this.$store && this.$store.state && this.$store.state.HOST) ? this.$store.state.HOST : ''
      if (!configuredHost) {
        return window.location.origin
      }

      // 手机上若仍是本地开发 HOST（127.0.0.1/localhost），则回退到当前页面域名
      const isLocalBackend = /^(https?:\/\/)?(127\.0\.0\.1|localhost)(:\d+)?$/i.test(configuredHost)
      const isCurrentLocal = /^(127\.0\.0\.1|localhost)$/i.test(window.location.hostname)
      if (isLocalBackend && !isCurrentLocal) {
        return window.location.origin
      }
      return configuredHost
    },

    buildMediaUrl(path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(path)) return path

      const normalizedPath = String(path).startsWith('/') ? path : `/${path}`

      const configuredHost = (this.$store && this.$store.state && this.$store.state.HOST) ? this.$store.state.HOST : ''
      const isLocalBackend = !configuredHost || /^(https?:\/\/)?(127\.0\.0\.1|localhost)(:\d+)?$/i.test(configuredHost)
      const isCurrentLocal = /^(127\.0\.0\.1|localhost)$/i.test(window.location.hostname)

      if (isLocalBackend && !isCurrentLocal) {
        // 手机端访问时，后端配置是本地地址但浏览器不在本地
        // 使用 API 代理路径，让 nginx 将请求转发到后端
        const apiBase = (process.env.VUE_APP_BASE_API || '/api').replace(/\/$/, '')
        return `${apiBase}${normalizedPath}`
      }

      const base = configuredHost ? configuredHost.replace(/\/$/, '') : window.location.origin
      return `${base}${normalizedPath}`
    },

    supportsGetUserMedia() {
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
    },

    isDingTalkEnv() {
      const ua = navigator.userAgent || ''
      return /dingtalk|aliapp/i.test(ua)
    },

    isSecureContextForCamera() {
      const host = window.location.hostname
      const isLocal = host === 'localhost' || host === '127.0.0.1'
      return window.isSecureContext || isLocal
    },

    triggerFallbackCamera() {
      const input = this.$refs.cameraFallbackInput
      if (!input) {
        this.$message.error('当前环境无法调用相机，请检查浏览器设置')
        return
      }

      try {
        // 重置值，确保重复选择同一张图片也能触发 change 事件
        input.value = ''
        // 保持在用户点击事件调用链内，避免部分 WebView 阻止弹起系统相机
        input.click()
      } catch (error) {
        console.error('调用系统拍照失败:', error)
        this.$message.error('调用系统相机失败，请检查权限设置')
      }
    },

    handleVisibilityChange() {
      if (document.hidden) {
        this.closeCamera()
      }
    },

    handlePageHide() {
      this.closeCamera()
    },

    // 加载用户信息
    async loadUserInfo() {
      // 如果 Vuex 中没有用户信息，尝试从服务器获取
      if (!this.getUserInfo && localStorage.getItem('user_token')) {
        try {
          await this.$store.dispatch('fetchUserInfo')
        } catch (error) {
          console.error('获取用户信息失败:', error)
          // 如果获取失败，跳转到登录页
          this.$message.error('登录已过期，请重新登录')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500)
        }
      }
    },
    // 加载视频详情
    async loadVideoDetail() {
      try {
        const random = Math.floor(Math.random() * 1000000)
        const res = await getVideoActivityById({ videoId: this.videoId, random })

        if (res.code === 1000) {
          // 活动记录可能不存在，不应阻断视频详情页
          if (res.data) {
            this.videoDetail = res.data
            // 获取打卡要求字段（0=可选打卡，1=必须打卡）
            this.requireCheckIn = res.data.requireCheckIn || 0
          } else {
            this.videoDetail = {}
            this.requireCheckIn = 0
          }
        } else {
          // 活动信息获取失败时降级，不中断视频播放
          this.videoDetail = {}
          this.requireCheckIn = 0
        }
      } catch (error) {
        console.error('加载视频详情失败:', error)
        // 活动信息非核心数据，失败时降级为可选打卡
        this.videoDetail = {}
        this.requireCheckIn = 0
      }
    },
    // 加载视频文件信息
    async loadVideoManage() {
      try {
        const random = Math.floor(Math.random() * 1000000)
        const res = await getVideoById({ id: this.videoId, random })

        if (res.code === 1000 && res.data) {
          // 更新活动信息中的字段
          this.activityInfo = {
            name: res.data.videoTitle || this.activityInfo.name,
            videoName: res.data.categoryName || this.activityInfo.videoName,
            time: res.data.createTime || this.activityInfo.time,
            author: res.data.createBy || this.activityInfo.author,
            category: res.data.categoryName || this.activityInfo.category,
            tags: res.data.tagNames || this.activityInfo.tags,
            viewCount: res.data.viewCount || this.activityInfo.viewCount,
            videoCover: this.getImageUrl(res.data.videoCover),
            videoUrl: this.getVideoUrl(res.data.videoUrl),
            videoDesc: this.activityInfo.videoDesc
          }
        }
      } catch (error) {
        console.error('加载视频文件信息失败:', error)
      }
    },

    // 获取图片URL
    getImageUrl(path) {
      if (!path) return DEFAULT_VIDEO_PLACEHOLDER
      return this.buildMediaUrl(path)
    },

    // 获取视频URL
    getVideoUrl(path) {
      if (!path) return ''
      return this.buildMediaUrl(path)
    },

    getVideoPlayerElement() {
      return this.$refs.videoPlayer || null
    },

    resetVideoPlaybackState() {
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
      this.videoLoadError = ''
      this.progressPercent = 0
      this.bufferedPercent = 0
      this.videoDuration = 0
    },

    updateBufferedProgress() {
      const videoPlayer = this.getVideoPlayerElement()
      if (!videoPlayer) {
        this.bufferedPercent = 0
        return
      }

      const duration = Number(videoPlayer.duration)
      if (!Number.isFinite(duration) || duration <= 0) {
        this.bufferedPercent = 0
        return
      }

      const buffered = videoPlayer.buffered
      if (!buffered || buffered.length === 0) {
        this.bufferedPercent = 0
        return
      }

      const currentTime = Number(videoPlayer.currentTime) || 0
      let activeRangeEnd = 0
      let maxRangeEnd = 0

      for (let i = 0; i < buffered.length; i++) {
        const rangeStart = Number(buffered.start(i)) || 0
        const rangeEnd = Number(buffered.end(i)) || 0
        maxRangeEnd = Math.max(maxRangeEnd, rangeEnd)
        if (currentTime >= rangeStart && currentTime <= rangeEnd) {
          activeRangeEnd = rangeEnd
        }
      }

      const bufferedEnd = activeRangeEnd || maxRangeEnd
      this.bufferedPercent = Math.min(100, Math.max(0, (bufferedEnd / duration) * 100))
    },

    // 播放视频
    playVideo() {
      if (this.activityInfo.videoUrl) {
        this.resetVideoPlaybackState()
        this.isVideoLoading = true
        // 打开视频播放器弹窗
        this.showVideoModal = true
        // 等待 DOM 更新后播放视频并进入全屏
        this.$nextTick(() => {
          const videoPlayer = this.getVideoPlayerElement()
          if (videoPlayer) {
            videoPlayer.load()
            // 播放视频
            videoPlayer.play().then(() => {
              // 尝试进入全屏模式
              this.enterFullscreen(videoPlayer)
            }).catch(error => {
              console.error('视频播放失败:', error)
              this.videoLoadError = '视频暂时无法播放，请稍后重试'
              this.isVideoLoading = false
              // 即使播放失败也尝试全屏
              this.enterFullscreen(videoPlayer)
            })
          }
        })
      } else {
        this.$message.warning('视频地址不存在')
      }
    },

    // 进入全屏
    enterFullscreen(element) {
      try {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullscreen) {
          // Safari
          element.webkitRequestFullscreen()
        } else if (element.mozRequestFullScreen) {
          // Firefox
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE/Edge
          element.msRequestFullscreen()
        }
      } catch (error) {
        console.error('进入全屏失败:', error)
      }
    },

    // 关闭视频播放器
    closeVideoPlayer() {
      const videoPlayer = this.getVideoPlayerElement()
      if (videoPlayer) {
        videoPlayer.pause()
        videoPlayer.currentTime = 0
      }
      if (typeof this.cleanupVideoProgress === 'function') {
        this.cleanupVideoProgress()
      }
      if (typeof this.resetVideoProgressState === 'function') {
        this.resetVideoProgressState()
      }
      this.resetVideoPlaybackState()
      this.showVideoModal = false
    },

    // 视频加载完成
    onVideoLoaded() {
      // 视频元数据加载完成，可以进行全屏等操作
      const videoPlayer = this.getVideoPlayerElement()
      if (videoPlayer) {
        const duration = Number(videoPlayer.duration)
        this.videoDuration = Number.isFinite(duration) && duration > 0 ? duration : 0
        this.progressPercent = this.videoDuration > 0 ? Math.min(100, Math.max(0, (Number(videoPlayer.currentTime) || 0) / this.videoDuration * 100)) : 0
      }
      this.updateBufferedProgress()
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
      this.videoLoadError = ''

      // 初始化播放进度功能
      if (videoPlayer && !this.isProgressLoaded) {
        this.initVideoProgress(this.videoId, videoPlayer)
      }
    },

    handlePlayerLoadStart() {
      this.isVideoLoading = true
      this.videoLoadingText = '视频加载中...'
      this.videoLoadError = ''
      this.bufferedPercent = 0
    },

    handlePlayerLoadedData() {
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
      this.updateBufferedProgress()
    },

    handlePlayerCanPlay() {
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
      this.videoLoadError = ''
      this.updateBufferedProgress()
    },

    handlePlayerPlaying() {
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
      this.videoLoadError = ''
      this.updateBufferedProgress()
    },

    handlePlayerWaiting() {
      const videoPlayer = this.getVideoPlayerElement()
      if (!videoPlayer || videoPlayer.paused || videoPlayer.ended || this.videoLoadError) {
        return
      }
      this.isVideoLoading = true
      this.videoLoadingText = '视频加载中请稍等'
    },

    handlePlayerStalled() {
      const videoPlayer = this.getVideoPlayerElement()
      if (!videoPlayer || videoPlayer.paused || videoPlayer.ended || this.videoLoadError) {
        return
      }
      this.isVideoLoading = true
      this.videoLoadingText = '视频加载中请稍等'
    },

    handlePlayerTimeUpdate() {
      const videoPlayer = this.getVideoPlayerElement()
      if (!videoPlayer) return
      const duration = Number(videoPlayer.duration)
      this.videoDuration = Number.isFinite(duration) && duration > 0 ? duration : 0
      const currentTime = Number(videoPlayer.currentTime) || 0
      this.progressPercent = this.videoDuration > 0
        ? Math.min(100, Math.max(0, (currentTime / this.videoDuration) * 100))
        : 0
      this.updateBufferedProgress()
    },

    handlePlayerProgress() {
      this.updateBufferedProgress()
    },

    handlePlayerPause() {
      if (!this.videoLoadError) {
        this.isVideoLoading = false
        this.videoLoadingText = '视频加载中...'
      }
    },

    handlePlayerEnded() {
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
    },

    handlePlayerError() {
      this.isVideoLoading = false
      this.videoLoadingText = '视频加载中...'
      this.videoLoadError = '视频加载失败，请稍后重试'
    },

    // 点击上传区域 - 打开摄像头
    handleUploadClick() {
      // 钉钉内置浏览器对网页摄像头能力限制较多，优先走系统拍照上传兜底
      if (this.isDingTalkEnv()) {
        this.triggerFallbackCamera()
        return
      }

      // 1) 不支持 getUserMedia：直接走系统拍照兜底
      if (!this.supportsGetUserMedia()) {
        this.$message.warning('当前浏览器不支持网页摄像头，已切换系统拍照上传')
        this.triggerFallbackCamera()
        return
      }

      // 2) 非安全上下文：getUserMedia 在多数手机浏览器会失败
      if (!this.isSecureContextForCamera()) {
        this.$message.warning('当前页面非 HTTPS，已切换系统拍照上传')
        this.triggerFallbackCamera()
        return
      }

      this.openCamera()
    },

    // 打开摄像头
    async openCamera() {
      if (this.isOpeningCamera) return
      this.isOpeningCamera = true
      try {
        if (this.isDingTalkEnv()) {
          this.triggerFallbackCamera()
          return
        }

        if (!this.supportsGetUserMedia()) {
          this.$message.warning('当前浏览器不支持网页摄像头，已切换系统拍照上传')
          this.triggerFallbackCamera()
          return
        }

        if (!this.isSecureContextForCamera()) {
          this.$message.warning('当前页面非 HTTPS，已切换系统拍照上传')
          this.triggerFallbackCamera()
          return
        }

        this.showCameraModal = true
        await this.$nextTick()

        const videoElement = this.$refs.cameraVideo
        if (!videoElement) {
          this.$message.error('无法找到视频元素')
          this.showCameraModal = false
          return
        }

        // 请求摄像头权限
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: { ideal: 'environment' },
            width: { ideal: 1280 },
            height: { ideal: 720 }
          },
          audio: false
        })

        this.cameraStream = stream
        videoElement.srcObject = stream
        await videoElement.play()
      } catch (error) {
        console.error('打开摄像头失败:', error)
        this.closeCamera()
        this.$message.warning('无法直接访问摄像头，已切换系统拍照上传')
        this.triggerFallbackCamera()
      } finally {
        this.isOpeningCamera = false
      }
    },

    async handleFallbackFileChange(event) {
      const file = event.target && event.target.files ? event.target.files[0] : null
      if (!file) return

      if (!file.type || !file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件')
        event.target.value = ''
        return
      }

      this.capturedImage = file
      await this.uploadPhoto()
      event.target.value = ''
    },

    // 拍照
    takePhoto() {
      const videoElement = this.$refs.cameraVideo
      const canvasElement = this.$refs.photoCanvas

      if (!videoElement || !canvasElement) {
        this.$message.error('拍照失败')
        return
      }

      if (!this.cameraStream || !this.cameraStream.active) {
        this.$message.warning('摄像头未就绪，请重新打开后再试')
        return
      }

      if (videoElement.readyState < 2 || !videoElement.videoWidth || !videoElement.videoHeight) {
        this.$message.warning('画面尚未加载完成，请稍后再拍照')
        return
      }

      const context = canvasElement.getContext('2d')
      canvasElement.width = videoElement.videoWidth
      canvasElement.height = videoElement.videoHeight
      context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height)

      // 转换为 blob
      canvasElement.toBlob((blob) => {
        this.capturedImage = blob
        this.closeCamera()
        this.uploadPhoto()
      }, 'image/jpeg', 0.9)
    },

    // 关闭摄像头
    closeCamera() {
      const videoElement = this.$refs.cameraVideo
      if (videoElement) {
        videoElement.pause()
        videoElement.srcObject = null
      }

      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(track => track.stop())
        this.cameraStream = null
      }
      this.showCameraModal = false
    },

    // 上传照片到服务器
    async uploadPhoto() {
      if (!this.capturedImage) {
        this.$message.warning('请先拍照')
        return
      }

      try {
        const res = await uploadFile(this.capturedImage)

        if (res.code === 1000) {
          // uploadFile 在不同环境下可能将路径放在 message 或 data 中（相对路径或完整URL）
          const messagePath = typeof res.message === 'string' ? res.message.trim() : ''
          const dataPath = typeof res.data === 'string' ? res.data.trim() : ''
          const imagePath = messagePath || dataPath

          if (!imagePath) {
            this.$message.error('照片上传成功，但未获取到图片地址')
            this.capturedImage = null
            this.uploadedImagePath = null
            return
          }

          this.uploadedImagePath = imagePath
          this.$message.success('照片上传成功')
        } else {
          this.$message.error('照片上传失败')
          this.capturedImage = null
        }
      } catch (error) {
        console.error('上传照片失败:', error)
        this.$message.error('照片上传失败，请重试')
        this.capturedImage = null
      }
    },

    // 重新拍照
    retakePhoto() {
      this.capturedImage = null
      this.uploadedImagePath = null
      this.openCamera()
    },

    // 提交打卡
    async handleSubmit() {
      // 表单验证
      if (this.requireCheckIn === 1 && !this.uploadedImagePath) {
        this.$message.warning('请先拍照')
        return
      }

      if (!this.note.trim()) {
        this.$message.warning('请输入打卡说明')
        return
      }

      if (this.isSubmitting) {
        return
      }

      try {
        this.isSubmitting = true

        const params = {
          taskId: this.videoId,
          content: this.note,
          avatar: this.userInfo.avatar || '',
          state: 2,
          userId: this.userInfo.userId || this.userInfo.id,
          createBy: this.userInfo.userName || '',
          taskName: this.activityInfo.name,
          thumbnail: this.uploadedImagePath || ''
        }

        const res = await saveApeArticle(params)

        if (res.code === 1000) {
          this.$message.success('打卡成功！')
          // 清空表单
          this.note = ''
          this.capturedImage = null
          this.uploadedImagePath = null
          // 可以选择跳转到打卡历史页面
          setTimeout(() => {
            this.$router.push('/activityVideo')
          }, 1500)
        } else {
          this.$message.error(res.message || '打卡失败，请重试')
        }
      } catch (error) {
        console.error('提交打卡失败:', error)
        this.$message.error('打卡失败，请重试')
      } finally {
        this.isSubmitting = false
      }
    },

    viewHistory() {
      this.$router.push('/center/clock')
    }
  }
}
</script>

<style scoped>


.video-detail-page {
  min-height: 100vh;
  background: #f0f2f4;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.camera-fallback-input {
  display: none;
}

/* 头部样式 */
.header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e5e7eb;
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 12px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 32px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #101318;
}

.logo-icon {
  width: 32px;
  height: 32px;
  background: rgba(26, 113, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a71ff;
}

.brand-name {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.search-box {
  position: relative;
  width: 256px;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 20px;
}

.search-box input {
  width: 100%;
  padding: 8px 12px 8px 40px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #f0f2f5;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.search-box input:focus {
  background: white;
  border-color: #1a71ff;
  box-shadow: 0 0 0 3px rgba(26, 113, 255, 0.1);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 24px;
}

.nav-link {
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.nav-link:hover {
  color: #1a71ff;
}

.nav-link.active {
  color: #101318;
  font-weight: 700;
}

.divider {
  width: 1px;
  height: 24px;
  background: #e5e7eb;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 8px;
}

.user-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-name {
  font-size: 12px;
  font-weight: 700;
  color: #101318;
}

.user-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
}

.status-dot {
  width: 6px;
  height: 6px;
  background: #10b981;
  border-radius: 50%;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.sync-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  background: #0089ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}


/* 主内容区 */
.main-content {
  flex: 1;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 32px 16px;
}

.content-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 面包屑 */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.breadcrumb-link {
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-link:hover {
  color: #1a71ff;
}

.breadcrumb-separator {
  color: #9ca3af;
  font-size: 16px;
}

.breadcrumb-current {
  color: #101318;
  font-weight: 600;
}

/* 页面标题 */
.page-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.page-title {
  font-size: 30px;
  font-weight: 800;
  color: #101318;
  margin: 0;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
}

/* 活动信息卡片 */
.activity-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
  overflow: hidden;
  display: flex;
  flex-direction: row;
}

.activity-thumbnail {
  width: 33.333%;
  min-height: 160px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.thumbnail-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transition: transform 0.5s;
}

.activity-thumbnail:hover .thumbnail-bg {
  transform: scale(1.05);
}

.thumbnail-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4));
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.activity-thumbnail:hover .thumbnail-overlay {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

.play-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.4);
}


.activity-info {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
}

.activity-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-name-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.activity-label {
  font-size: 12px;
  font-weight: 700;
  color: #1a71ff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.activity-name {
  font-size: 18px;
  font-weight: 700;
  color: #101318;
  margin: 0;
  line-height: 1.4;
}

.activity-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-label {
  color: #6b7280;
  width: 80px;
  flex-shrink: 0;
}

.detail-value {
  color: #101318;
  font-weight: 500;
}

.activity-requirement {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #ea580c;
  background: #fff7ed;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #fed7aa;
}


/* 打卡表单 */
.checkin-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-label {
  font-size: 14px;
  font-weight: 700;
  color: #101318;
}

.optional-tag {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
}

.required-tag {
  color: #ef4444;
  margin-left: 4px;
}

/* 上传区域 */
.upload-area {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s;
}

.upload-area:hover {
  border-color: #1a71ff;
  background: #f0f9ff;
}

.viewfinder-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: rgba(209, 213, 219, 0.7);
  border-style: solid;
  border-width: 0;
  transition: border-color 0.3s;
}

.upload-area:hover .viewfinder-corner {
  border-color: #1a71ff;
}

.corner-tl {
  top: 16px;
  left: 16px;
  border-top-width: 2px;
  border-left-width: 2px;
  border-top-left-radius: 8px;
}

.corner-tr {
  top: 16px;
  right: 16px;
  border-top-width: 2px;
  border-right-width: 2px;
  border-top-right-radius: 8px;
}

.corner-bl {
  bottom: 16px;
  left: 16px;
  border-bottom-width: 2px;
  border-left-width: 2px;
  border-bottom-left-radius: 8px;
}

.corner-br {
  bottom: 16px;
  right: 16px;
  border-bottom-width: 2px;
  border-right-width: 2px;
  border-bottom-right-radius: 8px;
}

.upload-content {
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  transition: transform 0.3s;
}

.upload-area:hover .upload-content {
  transform: scale(1.05);
}

.upload-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a71ff;
  transition: all 0.3s;
}

.upload-area:hover .upload-icon {
  background: #1a71ff;
  color: white;
}


.upload-text h4 {
  font-size: 16px;
  font-weight: 700;
  color: #101318;
  margin: 0 0 4px 0;
}

.upload-text p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.camera-btn {
  margin-top: 8px;
  padding: 8px 24px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #101318;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.camera-btn:hover {
  background: #f9fafb;
}

/* 文本域 */
.textarea-wrapper {
  position: relative;
}

.form-textarea {
  width: 100%;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  color: #101318;
  line-height: 1.6;
  resize: none;
  outline: none;
  transition: all 0.2s;
}

.form-textarea::placeholder {
  color: #9ca3af;
}

.form-textarea:focus {
  border-color: #1a71ff;
  box-shadow: 0 0 0 3px rgba(26, 113, 255, 0.1);
}

.char-count {
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-size: 12px;
  color: #9ca3af;
  pointer-events: none;
}

/* 表单按钮 */
.form-actions {
  padding-top: 24px;
  border-top: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  gap: 16px;
}

.submit-btn,
.history-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 32px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn {
  flex: 1;
  background: #1a71ff;
  color: white;
  box-shadow: 0 8px 16px rgba(26, 113, 255, 0.3);
}

.submit-btn:hover {
  background: #1557d0;
}

.submit-btn:active {
  transform: scale(0.98);
}


.history-btn {
  background: white;
  color: #101318;
  border: 1px solid #e5e7eb;
}

.history-btn:hover {
  background: #f9fafb;
}


/* 照片预览 */
.upload-area.has-photo {
  border-color: #10b981;
  background: #f0fdf4;
  cursor: default;
}

.photo-preview {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 6px;
}

.photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s;
}

.photo-preview:hover .photo-overlay {
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
}

.retake-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #101318;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.retake-btn:hover {
  transform: scale(1.05);
}


/* 摄像头弹窗 */
.camera-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.camera-container {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  max-width: 800px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.camera-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.camera-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #101318;
  margin: 0;
}

.close-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #e5e7eb;
  color: #101318;
}


.camera-body {
  position: relative;
  background: #000;
  aspect-ratio: 16/9;
  overflow: hidden;
}

.camera-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.camera-footer {
  padding: 24px;
  display: flex;
  justify-content: center;
  background: #f9fafb;
}

.capture-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  background: #1a71ff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(26, 113, 255, 0.3);
}

.capture-btn:hover {
  background: #1557d0;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(26, 113, 255, 0.4);
}

.capture-btn:active {
  transform: translateY(0);
}


/* 视频播放器弹窗 */
.video-player-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s;
}

.video-player-container {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  max-width: 1200px;
  width: 90%;
  max-height: 90vh;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  animation: slideUp 0.3s;
  display: flex;
  flex-direction: column;
}

.video-player-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.video-player-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  max-width: calc(100% - 50px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.video-player-body {
  position: relative;
  background: #000;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-player {
  width: 100%;
  height: 100%;
  max-height: calc(90vh - 60px);
  object-fit: contain;
  outline: none;
}

.player-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: none;
}

.player-loading-overlay.is-error {
  background: rgba(127, 29, 29, 0.5);
}

.player-loading-content {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(6px);
}

.player-loading-text {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  padding: 8px 14px;
  border-radius: 8px;
  background: rgba(127, 29, 29, 0.7);
}

.player-progress-wrap {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 14px;
  z-index: 4;
  pointer-events: none;
}

.player-progress-track {
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.28);
  overflow: hidden;
  position: relative;
}

.player-progress-buffered {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.55);
  transition: width 0.2s;
  z-index: 1;
}

.player-progress-played {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 999px;
  background: #1a71ff;
  transition: width 0.1s;
  z-index: 2;
}

/* 响应式 */
@media (max-width: 768px) {
  .header-container {
    padding: 12px 16px;
  }

  .search-box {
    display: none;
  }

  .nav-menu {
    display: none;
  }

  .activity-card {
    flex-direction: column;
  }

  .activity-thumbnail {
    width: 100%;
  }

  .form-actions {
    flex-direction: column;
  }

  .history-btn {
    width: 100%;
  }

  .camera-container {
    width: 95%;
    max-height: 90vh;
  }

  .camera-footer {
    padding: 16px;
  }

  .video-player-container {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .video-player {
    max-height: calc(100vh - 60px);
  }
}
</style>
